export const menus = [
    { id: 0, menu: "Profile", link: "/" },
    { id: 1, menu: "Projects", link: "projects" },
    { id: 2, menu: "Contacts", link: "contacts" },
]

export const slides = [
    {
        key: 0,
        fileLink: "https://arabank.netlify.app/",
        title: "Portfolio App",
        content: "This is my old portfolio app",
        stacks: ["React.js", "Material-UI"],
        url: "https://arabank.netlify.app/"
    },
    {
        key: 1,
        fileLink: "https://arabank-todolist.netlify.app/",
        title: "To-Do-List App",
        content: "A simple PWA To-do-list App",
        stacks: ["React.js,", "Boostrap"],
        url: "https://arabank-todolist.netlify.app/"
    },
    {
        key: 2,
        fileLink: "https://react-ecommerce-project-arabank.netlify.app/",
        title: "Ecommerce App",
        content: "An simple ecommerce app",
        stacks: ["React.js,", "Bootstrap"],
        url: "https://react-ecommerce-project-arabank.netlify.app/"
    },
    {
        key: 3,
        fileLink: "https://young-brushlands-35642.herokuapp.com/",
        title: "Exercise App",
        content: "An simple editable exercise app",
        stacks: ["React.js,", "Material-UI,", "Graphql"],
        url: "https://young-brushlands-35642.herokuapp.com/"
    },
    {
        key: 4,
        fileLink: "https://arabank-animations.netlify.app/",
        title: "React.js Animation Library",
        content: "Creating an animation library with react.js framework",
        stacks: ["React.js,", "Bootstrap"],
        url: "https://arabank-animations.netlify.app/"
    },
    {
        key: 5,
        fileLink: "https://arabank-contact.netlify.app/",
        title: "Contact Search App",
        content: "This app is aimed at creating a contact search concept by name",
        stacks: ["React.js,", "Bootstrap"],
        url: "https://arabank-contact.netlify.app/"
    },
    {
        key: 6,
        fileLink: "https://picsum.photos/800/804/?random",
        title: "Mobile Taxi App",
        content: "Created an easy to use mobile taxi app with react-native",
        stacks: ["React-Native,", "Bootstrap"],
        url: "https://expo.io/@oleariyah/projects/znappid-taxi"
    },
    {
        key: 7,
        fileLink: "https://picsum.photos/500/800/?random",
        title: "React-Native Custom",
        content: "This project is aimed at creating a custom bottom navbar",
        stacks: ["React-Native"],
        url: "https://expo.io/@oleariyah/projects/react-native-custom-components"
    },
    {
        key: 8,
        fileLink: "https://arabank-payment.netlify.app/",
        title: "Dashboard Development",
        content: "A dashboard development sample",
        stacks: ["React.js,", "Material-UI"],
        url: "https://arabank-payment.netlify.app/"
    },
]